import React, { useState } from 'react'
import { BiHeartCircle } from "react-icons/bi";
import { PiCaretDownBold } from "react-icons/pi";

const StatesCollapse = () => {
    const [show, setShow] = useState(false);

    const states = [
        { icon: <BiHeartCircle />, name: 'Alabama' },
        { icon: <BiHeartCircle />, name: 'Arizona' },
        { icon: <BiHeartCircle />, name: 'Arkansas' },
        { icon: <BiHeartCircle />, name: 'California' },
        { icon: <BiHeartCircle />, name: 'Delaware' },

        { icon: <BiHeartCircle />, name: 'Florida' },
        { icon: <BiHeartCircle />, name: 'Georgia' },
        { icon: <BiHeartCircle />, name: 'Idaho' },
        { icon: <BiHeartCircle />, name: 'Illinois' },
        { icon: <BiHeartCircle />, name: 'Indiana' },

        { icon: <BiHeartCircle />, name: 'Iowa' },
        { icon: <BiHeartCircle />, name: 'Kentucky' },
        { icon: <BiHeartCircle />, name: 'Louisiana' },
        { icon: <BiHeartCircle />, name: 'Maine' },

        { icon: <BiHeartCircle />, name: 'Michigan' },
        { icon: <BiHeartCircle />, name: 'Mississippi' },
        { icon: <BiHeartCircle />, name: 'Missouri' },
        { icon: <BiHeartCircle />, name: 'Nebraska' },
        { icon: <BiHeartCircle />, name: 'Nevada' },

        { icon: <BiHeartCircle />, name: 'New Mexico' },
        { icon: <BiHeartCircle />, name: 'North Carolina' },
        { icon: <BiHeartCircle />, name: 'Ohio' },
        { icon: <BiHeartCircle />, name: 'Oklahoma' },
        { icon: <BiHeartCircle />, name: 'Oregon' },

        { icon: <BiHeartCircle />, name: 'Pennsylvania' },
        { icon: <BiHeartCircle />, name: 'South Carolina' },
        { icon: <BiHeartCircle />, name: 'Tennessee' },
        { icon: <BiHeartCircle />, name: 'Texas' },
        { icon: <BiHeartCircle />, name: 'Utah' },

        { icon: <BiHeartCircle />, name: 'Virginia' },
        { icon: <BiHeartCircle />, name: 'Wisconsin' },
        { icon: <BiHeartCircle />, name: 'Wyoming' }
    ]

    return (
        <>
            <div className='text-2xl sm:text-4xl font-bold text-center'>We Offer Affordable Health Insurance in These States</div>

            <div className='flex flex-col items-center'>
                <ul className={`grid sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-y-4 gap-x-8 h-auto w-full ${show ? 'max-h-[2500px] md:max-h-[999px]' : 'max-h-72 sm:max-h-36'} md:duration-[2s] overflow-hidden`}>
                    {
                        states.map(state => (
                            <li className='flex items-center justify-center border border-slate-500 py-4 px-8 space-x-2' key={state.name}>
                                {/* <div className='text-secondary text-5xl'>{state.icon}</div> */}
                                <div>{state.name}</div>
                            </li>
                        ))
                    }
                </ul>
                <button className='btn btn-link btn-lg border' onClick={() => setShow(!show)}><PiCaretDownBold className={`text-7xl font-bold duration-[.5s] ${show ? 'rotate-180' : 'rotate-0'} `} /></button>
            </div>

            <div className='text-center'>We are licensed health insurance brokers that can help you find affordable family health insurance in your state. We currently help individuals, families, and small businesses in 34 states get coverage that offers more than standard Obamacare policies. If you live in any of these states, feel free to contact us to learn more about health insurance options available for your home or business.</div>
        </>
    )
}

export default StatesCollapse